import { TaskResponse } from '@dispatch/shared/types';
import { RadioField, TextField } from '@dispatch/web/ui';
import { Grid } from '@mui/material';
import {
  Control,
  FieldErrors,
  FieldValue,
  FieldValues,
  useFieldArray,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';

export type LocationInformationProps = {
  name: string;
  errors: FieldErrors;
  control: Control<FieldValues>;
  taskData?: TaskResponse;
  setValue?: UseFormSetValue<FieldValue<any>>;
  getValues?: UseFormGetValues<FieldValues>;
};

export const LocationInformation = ({
  name,
  control,
  errors,
  taskData,
}: LocationInformationProps) => {
  const { fields } = useFieldArray({
    control,
    name,
  });

  const lossLocation = taskData?.$msg?.claim?.lossLocation;

  return (
    <div style={{ width: '100%' }}>
      {fields.map((_, index) => (
        <Grid container spacing={2} alignItems="center" key={index}>
          <Grid size={11}>
            <Grid container spacing={1} alignItems="center">
              <Grid size={8}>
                <TextField
                  required
                  id={`${name}[${index}].location`}
                  name={`${name}[${index}].location`}
                  label="Location"
                  control={control}
                  error={
                    !lossLocation?.lat || !lossLocation?.lon
                      ? 'Address is Incorrect'
                      : undefined
                  }
                  errors={errors}
                  disabled
                />
              </Grid>
              <Grid size={3}>
                <RadioField
                  row
                  required
                  control={control}
                  id={`${name}[${index}].locationType`}
                  name={`${name}[${index}].locationType`}
                  buttons={[
                    {
                      label: 'Loss Location',
                      value: 'lossLocation',
                    },
                    { label: 'Other', value: 'other' },
                  ]}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </div>
  );
};
